"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieBanner = void 0;
const react_1 = __importStar(require("react"));
const Layout_1 = require("../Layout");
const Link_1 = require("../Link/Link");
const Text_1 = require("../Text/Text");
const CookieBanner_styles_1 = require("./CookieBanner.styles");
const CookieBanner_utils_1 = require("./CookieBanner.utils");
const COOKIE_POLICY_URL = "https://www.accurx.com/cookie-policy";
const CookieBanner = (_a) => {
    var { onAfterAccepted, onAfterDeclined } = _a, props = __rest(_a, ["onAfterAccepted", "onAfterDeclined"]);
    const [isDisplayed, setIsDisplayed] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setIsDisplayed((0, CookieBanner_utils_1.getCookieBannerResponse)() === null);
    }, [isDisplayed]);
    const handleAccept = () => {
        (0, CookieBanner_utils_1.setCookieBannerResponse)("accepted");
        onAfterAccepted === null || onAfterAccepted === void 0 ? void 0 : onAfterAccepted();
        setIsDisplayed(false);
    };
    const handleDecline = () => {
        (0, CookieBanner_utils_1.setCookieBannerResponse)("declined");
        onAfterDeclined === null || onAfterDeclined === void 0 ? void 0 : onAfterDeclined();
        setIsDisplayed(false);
    };
    if (!isDisplayed)
        return null;
    return (react_1.default.createElement(CookieBanner_styles_1.StyledGrid, Object.assign({ gap: "2" }, props),
        react_1.default.createElement(Text_1.Text, { as: "h2", variant: "subtitle", colour: "white", skinny: true }, "Cookies on this website"),
        react_1.default.createElement(Text_1.Text, { variant: "body", colour: "white", skinny: true },
            "We would like to use analytics cookies to give you the best experience. Our",
            " ",
            react_1.default.createElement(Link_1.Link, { theme: "dark", href: COOKIE_POLICY_URL, openInNewTab: true },
                react_1.default.createElement(Link_1.Link.Text, { text: "Cookie Policy" }),
                react_1.default.createElement(Link_1.Link.Icon, null)),
            " ",
            "tells you what cookies we collect and their purpose."),
        react_1.default.createElement(Layout_1.Flex, { gap: "1", flexDirection: {
                xs: "column",
                sm: "row",
            } },
            react_1.default.createElement(CookieBanner_styles_1.StyledButton, { theme: "secondary", text: "Yes, I agree", onClick: handleAccept }),
            react_1.default.createElement(CookieBanner_styles_1.StyledButton, { theme: "secondary", text: "No, do not use analytics cookies", onClick: handleDecline }))));
};
exports.CookieBanner = CookieBanner;
//# sourceMappingURL=CookieBanner.js.map